<template>
  <div class="about-page">
    <!-- 导航栏 -->
    <header class="navbar">
      <div class="container">
        <div class="logo">知予 AI</div>
        <nav class="nav-links">
          <router-link to="/">首页</router-link>
          <router-link to="/profit">盈利模式</router-link>
          <router-link to="/services">产品服务</router-link>
          <router-link to="/blog">心理科普</router-link>
          <router-link to="/about" class="active">关于我们</router-link>
        </nav>
        <div class="navbar-actions">
          <button class="btn-primary" @click="goToHome">立即体验</button>
        </div>
      </div>
    </header>

    <!-- 英雄区 -->
    <section class="about-hero">
      <div class="container">
        <h1 class="hero-title">关于知予 AI</h1>
        <p class="hero-desc">你的专属 AI 情绪树洞，温柔接住你的每一份情绪</p>
      </div>
    </section>

    <!-- 品牌故事 -->
    <section class="brand-story">
      <div class="container">
        <h2 class="section-title">品牌故事</h2>
        <div class="story-content">
          <div class="story-text">
            <p>知予 AI 心理陪伴平台诞生于2023年，由一群专业的心理学专家和技术团队共同创立。我们发现，在现代社会中，越来越多的人面临着心理压力和情绪困扰，但传统的心理咨询服务存在着门槛高、等待时间长、隐私性不足等问题。</p>
            <p>基于这一观察，我们决定利用人工智能技术，开发一个便捷、高效、隐私的心理陪伴平台，让更多人能够随时随地获得专业的心理支持。我们相信，每个人都应该拥有一个安全的情绪出口，都应该被温柔地倾听和理解。</p>
            <p>经过一年多的研发和测试，知予 AI 心理陪伴平台于2024年正式上线，通过 AI 技术为用户提供24小时在线的心理支持服务。我们的使命是通过科技力量，让心理健康服务触手可及，帮助每个人更好地应对生活中的挑战。</p>
          </div>
        </div>
      </div>
    </section>

    <!-- 发展历程 -->
    <section class="development-history">
      <div class="container">
        <h2 class="section-title">发展历程</h2>
        <div class="timeline">
          <div class="timeline-item">
            <div class="timeline-year">2023</div>
            <div class="timeline-content">
              <h3>项目启动</h3>
              <p>知予 AI 心理陪伴平台项目正式启动，组建专业团队开始研发</p>
            </div>
          </div>
          <div class="timeline-item">
            <div class="timeline-year">2024</div>
            <div class="timeline-content">
              <h3>平台上线</h3>
              <p>知予 AI 心理陪伴平台正式上线，开始为用户提供服务</p>
            </div>
          </div>
          <div class="timeline-item">
            <div class="timeline-year">2025</div>
            <div class="timeline-content">
              <h3>用户突破</h3>
              <p>平台用户突破100万，获得广泛好评</p>
            </div>
          </div>
          <div class="timeline-item">
            <div class="timeline-year">2026</div>
            <div class="timeline-content">
              <h3>服务升级</h3>
              <p>推出企业EAP服务，为企业提供员工心理援助计划</p>
            </div>
          </div>
        </div>
      </div>
    </section>



    <!-- 平台使命与价值观 -->
    <section class="mission-values">
      <div class="container">
        <h2 class="section-title">平台使命与价值观</h2>
        <div class="mission-values-content">
          <div class="mission">
            <h3 class="mission-title">我们的使命</h3>
            <p class="mission-desc">通过AI技术，让更多人能够获得及时、专业的心理支持，帮助每个人更好地应对生活中的挑战，提升心理健康水平。</p>
          </div>
          <div class="values">
            <h3 class="values-title">我们的价值观</h3>
            <ul class="values-list">
              <li>
                <i class="el-icon-check"></i>
                <span>用户至上：以用户需求为中心，提供优质的心理支持服务</span>
              </li>
              <li>
                <i class="el-icon-check"></i>
                <span>专业可信：基于科学的心理学知识，提供专业的心理支持</span>
              </li>
              <li>
                <i class="el-icon-check"></i>
                <span>创新进取：不断探索AI技术在心理健康领域的应用</span>
              </li>
              <li>
                <i class="el-icon-check"></i>
                <span>包容尊重：尊重每一位用户，提供包容的心理支持环境</span>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </section>

    <!-- 社会责任与荣誉 -->
    <section class="social-responsibility">
      <div class="container">
        <h2 class="section-title">社会责任与荣誉</h2>
        <div class="responsibility-honors">
          <div class="responsibility">
            <h3 class="responsibility-title">社会责任</h3>
            <ul class="responsibility-list">
              <li>
                <i class="el-icon-star-on"></i>
                <span>开展心理健康公益活动，普及心理健康知识</span>
              </li>
              <li>
                <i class="el-icon-star-on"></i>
                <span>为弱势群体提供免费的心理支持服务</span>
              </li>
              <li>
                <i class="el-icon-star-on"></i>
                <span>与学校合作，为学生提供心理健康教育</span>
              </li>
              <li>
                <i class="el-icon-star-on"></i>
                <span>参与社会心理健康公益项目，贡献企业力量</span>
              </li>
            </ul>
          </div>
          <div class="honors">
            <h3 class="honors-title">荣誉资质</h3>
            <ul class="honors-list">
              <li>
                <i class="el-icon-medal"></i>
                <span>2024年度心理健康科技创新奖</span>
              </li>
              <li>
                <i class="el-icon-medal"></i>
                <span>国家心理健康服务平台认证</span>
              </li>
              <li>
                <i class="el-icon-medal"></i>
                <span>用户最信赖的心理健康平台</span>
              </li>
              <li>
                <i class="el-icon-medal"></i>
                <span>科技向善优秀案例</span>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </section>

    <!-- 联系我们 -->
    <section class="contact-section">
      <div class="container">
        <h2 class="section-title">联系我们</h2>
        <div class="contact-content">
          <div class="contact-info">
            <p class="contact-item">
              <i class="el-icon-phone"></i>
              <span>联系电话：13100987983</span>
            </p>
            <p class="contact-item">
              <i class="el-icon-position"></i>
              <span>微信号：yxxgx9</span>
            </p>
            <p class="contact-item" style="align-items: flex-start;">
              <i class="el-icon-picture-outline"></i>
              <span><img src="https://h5smapp.dayujh.cn/upload/sys/image/69/9151955851f6033c3ac85bbdbea9a2.jpg" alt="微信二维码"
                    style="width: 220px;height: 300px;"></span>
            </p>
          </div>
          <div class="contact-form">
            <el-form :model="form" :rules="rules" ref="contactForm" label-position="top">
              <el-form-item label="姓名" prop="name">
                <el-input v-model="form.name" placeholder="请输入您的姓名"></el-input>
              </el-form-item>
              <el-form-item label="电话" prop="phone">
                <el-input v-model="form.phone" placeholder="请输入您的电话"></el-input>
              </el-form-item>
              <el-form-item label="公司名称" prop="company">
                <el-input v-model="form.company" placeholder="请输入您的公司名称"></el-input>
              </el-form-item>
              <el-form-item>
                <el-button type="primary" class="submit-btn" @click="submitForm" :loading="loading">提交</el-button>
              </el-form-item>
            </el-form>
          </div>
        </div>
      </div>
    </section>

    
  </div>
</template>

<script>
export default {
  name: 'About',
  data() {
    return {
      form: {
        name: '',
        phone: '',
        company: ''
      },
      rules: {
        name: [
          { required: true, message: '请输入姓名', trigger: 'blur' }
        ],
        phone: [
          { required: true, message: '请输入电话', trigger: 'blur' }
        ],
        company: [
          { required: false, message: '请输入公司名称', trigger: 'blur' }
        ]
      },
      loading: false
    }
  },
  methods: {
    goToHome() {
      this.$router.push('/');
    },
    submitForm() {
      this.$refs.contactForm.validate((valid) => {
        if (valid) {
          this.loading = true;
          // 构建请求参数
          const formData = {
            name: this.form.name,
            phone: this.form.phone,
            company: this.form.company
          };
          // 发送请求
          fetch('https://aixinli.dayujh.cn/admin/contact/submit', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json'
            },
            body: JSON.stringify(formData)
          })
          .then(response => response.json())
          .then(data => {
            this.loading = false;
            if (data.code === 200) {
              this.$message.success(data.msg);
              // 重置表单
              this.$refs.contactForm.resetFields();
            } else {
              this.$message.error(data.msg);
            }
          })
          .catch(error => {
            this.loading = false;
            this.$message.error('网络错误，请稍后重试');
            console.error('Error:', error);
          });
        } else {
          return false;
        }
      });
    }
  }
}
</script>

<style scoped>
.about-page {
  min-height: 100vh;
}

/* 导航栏 */
.navbar {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  background-color: rgba(255, 255, 255, 0.95);
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
  z-index: 1000;
  padding: 15px 0;
}

.navbar .container {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.logo {
  font-size: 24px;
  font-weight: bold;
  color: #9c89b8;
}

.nav-links {
  display: flex;
  gap: 20px;
}

.nav-links a {
  color: #333;
  text-decoration: none;
  font-size: 16px;
  transition: color 0.3s ease;
}

.nav-links a:hover {
  color: #9c89b8;
}

.nav-links .active {
  color: #9c89b8;
  font-weight: bold;
}

.navbar-actions {
  display: flex;
  gap: 10px;
}

.btn-primary {
  background: linear-gradient(135deg, #9c89b8, #b8bedd);
  color: white;
  border: none;
  padding: 10px 20px;
  border-radius: 25px;
  font-size: 16px;
  cursor: pointer;
  transition: all 0.3s ease;
}

.btn-primary:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(156, 137, 184, 0.3);
}

/* 英雄区 */
.about-hero {
  padding: 120px 0 80px;
  background: linear-gradient(135deg, #f5f7fa, #e9ecef);
  text-align: center;
}

.hero-title {
  font-size: 48px;
  font-weight: bold;
  color: #333;
  margin-bottom: 20px;
}

.hero-desc {
  font-size: 24px;
  color: #666;
  margin-bottom: 40px;
  max-width: 800px;
  margin-left: auto;
  margin-right: auto;
}

/* 通用区块样式 */
.section-title {
  font-size: 36px;
  font-weight: bold;
  color: #333;
  text-align: center;
  margin-bottom: 60px;
}

.container {
  width: 100%;
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 20px;
}

/* 品牌故事 */
.brand-story {
  padding: 80px 0;
  background-color: white;
}

.story-content {
  display: flex;
  gap: 60px;
  align-items: center;
  flex-wrap: wrap;
}

.story-image {
  flex: 1;
  min-width: 300px;
}

.story-image img {
  width: 100%;
  height: auto;
  border-radius: 20px;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.1);
}

.story-text {
  flex: 1;
  min-width: 300px;
  font-size: 16px;
  line-height: 1.8;
  color: #666;
}

.story-text p {
  margin-bottom: 20px;
}

/* 发展历程 */
.development-history {
  padding: 80px 0;
  background: linear-gradient(135deg, #f5f7fa, #e9ecef);
}

.timeline {
  position: relative;
  max-width: 800px;
  margin: 0 auto;
}

.timeline::before {
  content: '';
  position: absolute;
  left: 50%;
  top: 0;
  bottom: 0;
  width: 2px;
  background: linear-gradient(135deg, #9c89b8, #b8bedd);
  transform: translateX(-50%);
}

.timeline-item {
  position: relative;
  margin-bottom: 60px;
  display: flex;
  align-items: center;
}

.timeline-year {
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
  width: 80px;
  height: 80px;
  background: linear-gradient(135deg, #9c89b8, #b8bedd);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  font-size: 18px;
  font-weight: bold;
  z-index: 1;
}

.timeline-content {
  background-color: white;
  padding: 30px;
  border-radius: 20px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05);
  width: 45%;
}

.timeline-item:nth-child(odd) .timeline-content {
  margin-right: 55%;
}

.timeline-item:nth-child(even) .timeline-content {
  margin-left: 55%;
}

.timeline-content h3 {
  font-size: 20px;
  font-weight: bold;
  color: #333;
  margin-bottom: 10px;
}

.timeline-content p {
  font-size: 16px;
  color: #666;
}



/* 平台使命与价值观 */
.mission-values {
  padding: 80px 0;
  background: linear-gradient(135deg, #f5f7fa, #e9ecef);
}

.mission-values-content {
  display: flex;
  gap: 60px;
  flex-wrap: wrap;
}

.mission {
  flex: 1;
  min-width: 300px;
  background-color: white;
  padding: 30px;
  border-radius: 20px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05);
}

.mission-title {
  font-size: 24px;
  font-weight: bold;
  color: #333;
  margin-bottom: 20px;
  text-align: center;
}

.mission-desc {
  font-size: 16px;
  color: #666;
  line-height: 1.8;
  text-align: center;
}

.values {
  flex: 1;
  min-width: 300px;
  background-color: white;
  padding: 30px;
  border-radius: 20px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05);
}

.values-title {
  font-size: 24px;
  font-weight: bold;
  color: #333;
  margin-bottom: 20px;
  text-align: center;
}

.values-list {
  list-style: none;
}

.values-list li {
  display: flex;
  align-items: flex-start;
  gap: 15px;
  margin-bottom: 20px;
  font-size: 16px;
  color: #666;
  line-height: 1.6;
}

.values-list li i {
  color: #9c89b8;
  font-size: 20px;
  margin-top: 2px;
}

/* 社会责任与荣誉 */
.social-responsibility {
  padding: 80px 0;
  background-color: white;
}

.responsibility-honors {
  display: flex;
  gap: 60px;
  flex-wrap: wrap;
}

.responsibility {
  flex: 1;
  min-width: 300px;
  background-color: #f9f9f9;
  padding: 30px;
  border-radius: 20px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05);
}

.responsibility-title {
  font-size: 24px;
  font-weight: bold;
  color: #333;
  margin-bottom: 20px;
  text-align: center;
}

.responsibility-list {
  list-style: none;
}

.responsibility-list li {
  display: flex;
  align-items: flex-start;
  gap: 15px;
  margin-bottom: 20px;
  font-size: 16px;
  color: #666;
  line-height: 1.6;
}

.responsibility-list li i {
  color: #9c89b8;
  font-size: 20px;
  margin-top: 2px;
}

.honors {
  flex: 1;
  min-width: 300px;
  background-color: #f9f9f9;
  padding: 30px;
  border-radius: 20px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05);
}

.honors-title {
  font-size: 24px;
  font-weight: bold;
  color: #333;
  margin-bottom: 20px;
  text-align: center;
}

.honors-list {
  list-style: none;
}

.honors-list li {
  display: flex;
  align-items: flex-start;
  gap: 15px;
  margin-bottom: 20px;
  font-size: 16px;
  color: #666;
  line-height: 1.6;
}

.honors-list li i {
  color: #9c89b8;
  font-size: 20px;
  margin-top: 2px;
}

/* 联系我们 */
.contact-section {
  padding: 80px 0;
  background: linear-gradient(135deg, #f5f7fa, #e9ecef);
}

.contact-content {
  display: flex;
  gap: 60px;
  flex-wrap: wrap;
}

.contact-info {
  flex: 1;
  min-width: 300px;
}

.contact-subtitle {
  font-size: 24px;
  font-weight: bold;
  color: #333;
  margin-bottom: 20px;
}

.contact-item {
  display: flex;
  align-items: center;
  gap: 15px;
  margin-bottom: 20px;
  font-size: 16px;
  color: #666;
}

.contact-item i {
  color: #9c89b8;
  font-size: 20px;
}

.contact-form {
  flex: 1;
  min-width: 300px;
  background-color: white;
  padding: 30px;
  border-radius: 20px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05);
}

/* 页脚 */
.footer {
  background-color: #333;
  color: white;
  padding: 60px 0 30px;
}

.footer-content {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
  gap: 40px;
  margin-bottom: 40px;
}

.footer-logo h3 {
  font-size: 24px;
  margin-bottom: 10px;
  color: #9c89b8;
}

.footer-logo p {
  color: rgba(255, 255, 255, 0.7);
  margin-bottom: 20px;
}

.footer-links h4 {
  font-size: 18px;
  margin-bottom: 20px;
  color: white;
}

.footer-links ul {
  list-style: none;
}

.footer-links li {
  margin-bottom: 10px;
}

.footer-links a {
  color: rgba(255, 255, 255, 0.7);
  text-decoration: none;
  transition: color 0.3s ease;
}

.footer-links a:hover {
  color: #9c89b8;
}

.footer-contact h4 {
  font-size: 18px;
  margin-bottom: 20px;
  color: white;
}

.footer-contact p {
  color: rgba(255, 255, 255, 0.7);
  margin-bottom: 10px;
}

.footer-copyright {
  text-align: center;
  padding-top: 30px;
  border-top: 1px solid rgba(255, 255, 255, 0.1);
  color: rgba(255, 255, 255, 0.7);
  font-size: 14px;
}

.footer-copyright p {
  margin-bottom: 5px;
}

/* 响应式设计 */
@media (max-width: 768px) {
  .navbar .container {
    flex-direction: column;
    gap: 10px;
  }
  
  .nav-links {
    flex-wrap: wrap;
    justify-content: center;
  }
  
  .hero-title {
    font-size: 36px;
  }
  
  .story-content {
    flex-direction: column;
  }
  
  .timeline::before {
    left: 20px;
  }
  
  .timeline-year {
    left: 20px;
  }
  
  .timeline-content {
    width: calc(100% - 60px);
    margin-left: 60px !important;
    margin-right: 0 !important;
  }
  
  .mission-values-content {
    flex-direction: column;
  }
  
  .responsibility-honors {
    flex-direction: column;
  }
  
  .contact-content {
    flex-direction: column;
  }
}

@media (max-width: 480px) {
  .hero-title {
    font-size: 28px;
  }
  
  .section-title {
    font-size: 28px;
  }
  
  .team-grid {
    grid-template-columns: 1fr;
  }
}
</style>